import { ajax } from './ajax'
// 课后拓展 接口

// 首页分页查询
export const reqExpandWord = (paramets) => ajax(`/homework/jxHomework/list`,paramets);

// 通过id删除作业
export const reqDelWork = (paramets) => ajax(`/homework/jxHomework/delete`,paramets,'delete')

// 批量删除作业
export const reqDelWorkList = (paramets) => ajax(`/homework/jxHomework/deleteBatch`,paramets,'delete')

// 修改时间、作业编辑 
export const reqEditWork = (paramets) => ajax(`/homework/jxHomework/edit`,paramets,'put')

// 新增作业
export const reqAddWork = (paramets) => ajax(`/homework/jxHomework/add`,paramets,'post')

// id获取作业
export const reqGetWorkID = (paramets) => ajax(`/homework/jxHomework/queryById`,paramets)

// id获取作业附件
export const reqGetWorkFj = (paramets) => ajax(`/homework/jxHomework/queryJxHomeworkEnclosureByMainId`,paramets)

// id发布
export const reqPostWork = (paramets) => ajax(`/homework/jxHomework/releasehw`,paramets,'post')

// id查看
export const reqGetWorkTopic = (paramets) => ajax(`/homework/jxHomework/GetStuList`,paramets)

// 获取未上交学生名单 
export const reqGetNotSubmit = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/getStulists`,paramets)

// 获取未上交学生数量
export const reqGetNotSubmitTotal = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/getStuCount`,paramets)

// 课后拓展 - 查看 - id批阅-获取-内容  
export const reqIdGetScoring = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/queryById`,paramets)

// 课后拓展 - 查看 - id批阅-获取附件
export const reqIdGetScoringFj = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/queryJxHomeworkStuDetailByMainId`,paramets)

// 课后拓展 - 查看 - id批阅-编辑-内容
export const reqIdEditScoring = (paramets) => ajax(`/homeworkstu/jxHomeworkStuReview/homeworkReview`,paramets,'post')

// 课后拓展 - 查看 - id批阅-编辑-内容-测验
export const reqEditTestScoring = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/edit`,paramets,'put')

// 批量打分
export const reqBatchTotal = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/BatchReview`,paramets,'put')

// 批量驳回
export const reqBatchReject = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/homeworkrejects`,paramets)

// 导出 
// 暂时先留下 
export const reqExportExcel = (paramets) => ajax(`/homeworkstu/jxHomeworkStu/exportXls`,paramets)

// 批量提醒未上交学生
export const reqRemindStudent = (paramets) => ajax(`/HomeworkNoreminder/jxHomeworkNoreminder/Batchreminders`,paramets,'post')

// 作业添加测验保存
export const reqHomeworkTestAdd = (paramets) => ajax(`/homeworktest/jxHomeworkTest/add`,paramets, 'post')

// 作业添加测验查询
export const reqHomeworkTestById = (paramets) => ajax(`/test/jxTest/gettestshow`,paramets)

// 作业添加测验编辑
export const reqHomeworkTestEdit = (paramets) => ajax(`/homeworktest/jxHomeworkTest/edit`,paramets, 'put')



// WEBPACK FOOTER //
// ./src/api/khExpand.js